"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
var validators = {
  /**
   * 可区分全角字符/半角字符的长度校验
   *
   * @param min
   * @param max
   * @param title
   * @returns {Function}
   */
  length: function length(_ref) {
    var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100000000 : _ref$max,
      title = _ref.title;
    return function (rule, value, callback) {
      var realLength = 0;
      var realMax = 0;
      //将一个全角字符替换成两个半角字符，以得到真实长度。
      if (value) {
        if (typeof value === 'number') {
          realLength = value.toString().length;
        } else {
          for (var i = 0; i < value.length && realMax == 0; i++) {
            var charCode = value.charCodeAt(i);
            // 按生产 AL16UTF16 编码推算
            // 13位最小二进制，占 3 个字节
            if (charCode >= 0x0800) {
              realLength += 3;
            }
            // 8位最小二进制，占 2 个字节
            else if (charCode >= 0x0080) {
              realLength += 2;
            } else {
              realLength += 1;
            }

            // 超长的最大字符数
            if (realLength > max) {
              realMax = i;
            }
            /*if (charCode >= 0x4E00 && charCode <= 0x9FA5) {
              // 中文字符的Unicode编码范围
              realLength += 3;
            } else {
              realLength += 1;
            }*/
          }
        }
      }
      title = title ? title : '';
      realLength <= max && realLength >= min ? callback() : max < 100000000 ? callback(title + '输入长度应在' + min + '到' + realMax + '个字符之间！') : callback(title + '至少应输入' + min + '个字符！');
    };
  }
};
var _default = exports.default = validators;